import React, { useEffect } from "react";
import { PageContainer } from "@/components/ui/PageContainer";
import { SeoHead } from "@/components/seo/SeoHead";

const EligibilityTest: React.FC = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://tally.so/widgets/embed.js";
    script.async = true;
    document.body.appendChild(script);
    return () => { document.body.removeChild(script); };
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <SeoHead
        title="Eligibility Test"
        description="Quick eligibility questionnaire."
        canonicalPath="/tools/eligibility-test"
      />

      <header className="border-b border-border/60 bg-gradient-to-b from-white to-muted/20">
        <PageContainer center>
          <div className="py-8 md:py-12">
            <h1 className="text-2xl md:text-3xl font-semibold tracking-tight">Eligibility Test</h1>
            <p className="mt-2 text-muted-foreground">Complete this quick survey.</p>
          </div>
        </PageContainer>
      </header>

      <main>
        <PageContainer center>
          <section className="py-6">
            <div className="rounded-lg border bg-card p-4">
              <iframe
                data-tally-src="https://tally.so/embed/wLaXxp?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
                loading="lazy"
                width="100%"
                height="520"
                frameBorder={0}
                title="Eligibility"
                className="w-full"
              />
            </div>
          </section>
        </PageContainer>
      </main>
    </div>
  );
};

export default EligibilityTest;
